/*
 * Copyright 2020 Red Hat, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BoxedExpressionEditorI18n } from "..";
import { en as en_common } from "@kogito-tooling/i18n-common-dictionary";

export const en: BoxedExpressionEditorI18n = {
  ...en_common,
  addParameter: "Add parameter",
  choose: "Choose...",
  class: "class",
  clear: "Clear",
  columnOperations: {
    delete: "Delete",
    insertLeft: "Insert left",
    insertRight: "Insert right",
  },
  columns: "COLUMNS",
  context: "Context",
  contextEntry: "CONTEXT ENTRY",
  dataType: "Data Type",
  decisionTable: "Decision Table",
  delete: "Delete",
  editContextEntry: "Edit Context Entry",
  editExpression: "Edit Expression",
  editParameter: "Edit Parameter",
  editParameters: "Edit parameters",
  editRelation: "Edit Relation",
  enterFunction: "Enter function",
  function: "Function",
  invocation: "Invocation",
  list: "List",
  literalExpression: "Literal expression",
  methodSignature: "method signature",
  name: "Name",
  parameters: "PARAMETERS",
  relation: "Relation",
  rowOperations: {
    clear: "Clear",
    delete: "Delete",
    insertAbove: "Insert above",
    insertBelow: "Insert below",
  },
  rows: "ROWS",
  selectExpression: "Select expression",
  selectFunctionKind: "Select Function Kind",
  selectLogicType: "Select logic type",
};
